var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 53,
    viewBox: "0 0 54 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.417969,
    width: 52.8387,
    height: 52.8387,
    rx: 26.4194,
    fill: "#EDF2F7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_189_16061)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.3833 21.8901V22.749C30.2119 22.2342 31.1685 21.9342 32.622 21.9342C37.3525 21.9342 37.9582 25.4701 37.9582 28.5504V36.9518L32.4884 37V28.9647C32.4884 27.6159 32.0053 27.3599 31.1121 27.3599C30.2628 27.3599 29.7357 27.6283 29.7357 28.9647V37L24.1944 36.9518V21.8901L29.3833 21.8901ZM21.5055 21.8811V36.9937H16V21.8811H21.5055V21.8811ZM20.1291 23.2574H17.3764V35.6173H20.1291V23.2574V23.2574ZM28.007 23.2665H25.5708V35.5878L28.3593 35.6126V28.9647C28.3593 26.3702 30.0839 25.9835 31.1121 25.9835C32.3673 25.9835 33.8648 26.501 33.8648 28.9647V35.6126L36.5818 35.5878V28.5504C36.5818 24.731 35.5096 23.3106 32.622 23.3106C30.8863 23.3106 30.1348 23.8253 29.3985 24.4447L29.2072 24.6071H28.007V23.2665ZM18.7528 15C20.2709 15 21.5055 16.2346 21.5055 17.7528C21.5055 19.2709 20.2709 20.5055 18.7528 20.5055C17.2346 20.5055 16 19.2709 16 17.7528C16 16.2346 17.2346 15 18.7528 15ZM18.7528 16.3764C17.9944 16.3764 17.3764 16.9944 17.3764 17.7528C17.3764 18.5111 17.9944 19.1291 18.7528 19.1291C19.5111 19.1291 20.1291 18.5111 20.1291 17.7528C20.1291 16.9944 19.5111 16.3764 18.7528 16.3764Z",
    fill: "#006779"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_189_16061"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(16 15)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.9bf0bec224822aede220376dd1bad231.svg";
export { ForwardRef as ReactComponent };